
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-mermaid.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-plugin-mermaid-demo-basic","docs-x-markdown-plugin-mermaid-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-mermaid.zh-CN.md?type=demo')
};